import { useEffect } from 'react';
import { ChargebeeContextProvider } from 'lib/contexts/ChargebeeContext';
import useSubscription from 'lib/hooks/useSubscription';

import {
  LoadingScreen,
  useModal,
  usePrevious,
} from '@frontendmentorio/design-system-v2';

import Ecologi from './Ecologi';
import ErrorModal from './ErrorModal';
import FAQs from './FAQs';
import Hero from './Hero';
import More from './More';
import Plans from './Plans';
import ReadyToStart from './ReadyToStart';
import SuccessModal from './SuccessModal';
import Testimonials1 from './Testimonials1';
import Testimonials2 from './Testimonials2';
import Testimonials3 from './Testimonials3';
import Why from './Why';

export default function Pro() {
  const successModal = useModal();
  const errorModal = useModal();

  const { status, statusMessage } = useSubscription();

  const previousStatus = usePrevious(status);

  useEffect(() => {
    if (previousStatus !== 'loading') return;
    if (status === 'idle' || status === 'loading') return;

    if (status === 'success') successModal.open?.();
    if (status === 'failed') errorModal.open?.();
  }, [errorModal.open, previousStatus, status, successModal.open]);

  return (
    <ChargebeeContextProvider>
      {status === 'loading' && <LoadingScreen message={statusMessage} />}

      <Hero />
      <Testimonials1 />
      <Why />
      <More />
      <Testimonials2 />
      <Plans withCheckout />
      <Ecologi />
      <Testimonials3 />
      <FAQs />
      <ReadyToStart />

      <SuccessModal modal={successModal} />
      <ErrorModal modal={errorModal} />
    </ChargebeeContextProvider>
  );
}
